import * as React from 'react';

import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';

import * as LoginState from '@common/react/store/Login';
import { FileInterface, FileType } from '@common/typescript/objects/FileInterface';
import File from '@common/react/components/Forms/Files/File';
import { AlertMessage } from '@common/react/components/UI/AlertMessage/AlertMessage';
import { BaseApplicationState } from '@common/react/store';

import selfieImg from '@app/images/selfie.png';
import { User } from '@app/objects/User';

interface ComponentProps {
	renderButtons: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit: (userData?: User) => void;
	user: User;
}

type LoginActions = LoginState.LoginActionCreators<User, BaseApplicationState<User>>;

export const PatientPhoto: React.FC<ComponentProps> = (props) => {
	const [error, setError] = React.useState<string>('');
	const [src, setSrc] = React.useState<string>(props.user.originalAvatar);

	const dispatch = useDispatch();
	const loginActions: LoginActions = bindActionCreators(LoginState.getActionCreators(), dispatch);

	React.useEffect(() => {
		if (props.user.avatar || props.user.originalAvatar) {
			props.afterSubmit();
		}
	}, [props.user]);

	const updateFile = (result: FileInterface) => {
		loginActions.updateUser({ avatar: result.thumb, originalAvatar: result.src });
		setError('');
		setSrc(result.src);
	};

	const handleSubmit = () => {
		props.afterSubmit();
	};

	return <div className="patient-register-page__photo">
		<h4 className="text-center">
			Make sure your face is
			{' '}
			<b>centered in the frame</b>
			{' '}
			and there is
			{' '}
			<b>ample lighting</b>
			.
		</h4>
		<div className="photo-block__wrapper">
			<img className="photo-block__img" src={src || selfieImg} alt="Avatar" height={130} />
		</div>
		<File
			buttonCaption={<div>
				<i className="fa fa-camera mr10" />
				Take Photo
			</div>}
			asButton
			objectId={props.user.id}
			type="user"
			update={updateFile}
			fileType={FileType.Avatar}
			buttonClassName="btn btn-default pull-left"
			onError={setError}
		/>
		{props.renderButtons(handleSubmit)}
		<AlertMessage message={error} />
	</div>;
};
